<div class="hero-body">
	<div class="container has-text-centered">
		<h1 class="title blue">
			¡Gracias!
		</h1>
		<h2 class="subtitle">
			Hemos recibido tu mensaje y en breve nos comunicaremos contigo.
		</h2>
		<a routerLink="/" class="button is-danger">Volver</a>
	</div>
</div>
